import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './RefreshIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const RefreshIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function RefreshIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 38 44" component={Icon} {...props} />
  );
});
